// The public feedback page for a training's current run: /feedback/[slug].
//
// Links handed out before editions existed carry no edition number, so this
// resolves to the newest edition whose form is open — see
// getPublicQuestionnaire. Each run's own link is /feedback/[slug]/[edition].

import { createFileRoute } from "@tanstack/react-router";
import {
	FeedbackPage,
	feedbackHead,
} from "#/components/questionnaire/feedback-page";
import { getPublicQuestionnaire } from "#/lib/questionnaire-server";

export const Route = createFileRoute("/feedback/$slug")({
	loader: ({ params }) =>
		getPublicQuestionnaire({ data: { slug: params.slug } }),
	head: ({ loaderData }) => feedbackHead(loaderData),
	component: CurrentEditionFeedbackPage,
});

function CurrentEditionFeedbackPage() {
	return <FeedbackPage data={Route.useLoaderData()} />;
}
